<template>
  <div class="z-60">
    <Side v-if="side" :title="title" :content="content" :show="show" side @close="close">
      <template v-slot:component>
        <slot name="component"></slot>
      </template>
    </Side>
    <div v-else>
      <div
        class="h-screen w-screen fixed top-0 popup-bg left-0 z-60"
        :class="{ 'popup-bg--show': show, 'hidden md:block': !drawer }"
        @click="close"
        :v-if="!disableClose"
      ></div>
      <div
        class="
          popup
          p-8
          sm:p-10
          z-60
          fixed
          left-1/2
          top-1/2
          w-screen
          min-h-screen
          max-h-screen
          sm:min-h-auto sm:w-auto
          overflow-y-hidden
          -translate-y-1/2 -translate-x-1/2
          transform
          scale-0
        "
        :class="{
          'overflow-y-auto scale-100': show && !side,
          'overflow-y-auto scale-100 popup--show-side': show && side,
          'popup--side sm:right-0 sm:left-auto sm:top-0  sm:h-screen': side,
          'popup--doctype': docFormat,
          'bg-white' : drawer,
          'bg-green-8 sm:bg-white flex flex-col justify-between': !drawer,
          'popup--show' : drawer && show,
          'popup--show-no-drawer': !drawer && show,
          'rounded-none': side
        }"
      >
        <div class="flex flex-col">
          <div
            class="w-16 h-16 mb-6 rounded-3xl relative"
            :class="(drawer ? iconBg : iconBg) + (align === 'center' && drawer ? ' mx-auto' : ' sm:mx-auto')"
            v-if="icon"
          >
            <div
              class="
                absolute
                left-1/2
                top-1/2
                transform
                -translate-x-1/2 -translate-y-1/2
              "
            >
              <img :src="icon" :alt="icon" class="min-h-5" />
            </div>
          </div>
          <div
            class="text-grey-2 mb-10 mt-6 sm:mt-0 text-xl font-medium"
            v-html="title"
            :class="drawer ? ('text-' + align) : ('text-left sm:text-' + align)"
            v-if="title"
          ></div>
          <div :class="side? 'popup-content-wrapper' : ''">
            <div class="max-h-content text-grey-3 overflow-y-auto popup-content" :class="drawer ? ('text-' + align) : ('text-left sm:text-' + align)">
              <slot name="content">{{ content }}</slot>
              <slot name="component"></slot>
            </div>
            <!-- contentFooterLink -->
            <div v-if="contentFooterLink != null" class="mt-2 text-left md:text-center font-semibold">
              <span class=" text-orange-1 cursor-pointer" @click="openNewTab">
              {{ $t("wording.learn_more_validation") }}
              </span>
            </div>
          </div>
        </div>
        <div :class="{'md:flex': sideBySideButtons, 'md:mx-auto': !sideBySideButtons }" class="mt-10 gap-4" v-if="secondaryButton || primaryButton">
          <gp-button
            color="white"
            class="mb-4 md:mb-0"
            v-if="secondaryButton"
            @click="close('secondary')"
          >
            {{ secondaryButton }}
          </gp-button>
          <gp-button
            v-if="primaryButton"
            @click="close('primary')"
            :class="{'md:mt-4': !sideBySideButtons, 'mx-auto': sideBySideButtons }"
          >
            {{ primaryButton }}
          </gp-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GpButton from '@/components/general/GpButton.vue'
import { useRouter } from 'vue-router'
import Side from "@/components/general/popup/Side.vue";

export default {
  components: {
    Side,
    GpButton
  },
  props: {
    title: String,
    content: String,
    contentFooterLink: {
      type: String,
      default: null
    },
    primaryButton: String,
    secondaryButton: String,
    show: Boolean,
    align: {
      type: String,
      default: 'left'
    },
    side: {
      type: Boolean,
      default: true
    },
    disableClose: {
      type: Boolean,
      default: false
    },
    drawer: {
      type: Boolean,
      default: false
    },
    docFormat: {
      type: Boolean,
      default: false
    },
    icon: String,
    sideBySideButtons: {
      type: Boolean,
      default: true
    },
    iconBg: {
      type: String,
      default: 'bg-grey-7'
    },
    primaryLink: String,
    // For a primary action a plain link can't express, e.g. navigating with route params
    primaryCallback: Function,
    secondaryLink: String,
    bgLink: String
  },
  emits: ['close'],
  setup(props, { emit }) {
    const router = useRouter()

    function close(type) {
      if (props.primaryCallback && type === 'primary') {
        const callback = props.primaryCallback
        emit('close', type)
        callback()
      } else if (
        (props.primaryLink && type === 'primary') ||
        (props.secondaryLink && type === 'secondary')
      ) {
        router.push(
          type === 'primary' ? props.primaryLink : props.secondaryLink
        )
        emit('close', type)
      } else {
        if(props.bgLink)
          router.push(props.bgLink)
        emit('close', type)
      }
    }

    function openNewTab() {
      window.open(props.contentFooterLink, "_blank");
    }
    return {
      close,
      openNewTab
    }
  }
}
</script>
<style scoped>

.popup--doctype {
  width: 100vw !important;
  height: 100dvh !important;
  height: 100vh !important;
  max-width: 100vw !important;
  max-height: 100dvh !important;
  max-height: 100vh !important;
  min-width: 100vw !important;
  min-height: 100dvh !important;
  min-height: 100vh !important;
  border-radius: 0 !important;
  padding: 1 !important;
  background: white !important;
  top: 0 !important;
  left: 0 !important;
  bottom: 0 !important;
  transform: none !important;
  position: fixed !important;
  display: flex;
  flex-direction: column;
}

.popup {
  border-radius: 3rem;
  transition: all 0.2s ease-in-out;
  opacity: 0;
}

.popup--side {
  transform: translate(-50%, 0%) scale(1);
  max-width: 40rem;
}

@media (min-width: 640px) {
  .popup--side {
    transform: translate(200%, 0%);
    border-radius: 0;
  }

  .popup--show {
    border-radius: 48px;
    transform: translate(-50%, -50%);
    opacity: 1;
  }

  .popup--show-no-drawer{
    border-radius: 48px;
    transform: translate(-50%, -50%);
    opacity: 1;
  }

  .popup--show-side {
    transform: translate(0%, 0%);
    border-radius: 0px;
    pointer-events: all;
    opacity: 1;
  }
}


.popup-bg {
  background-color: rgba(79, 89, 99, 0);
  transition: all 0.2s ease-in-out;
  pointer-events: none;
  backdrop-filter: blur(0px);
}
.popup-bg--show {
  pointer-events: all;
  backdrop-filter: blur(2px);
  background-color: rgba(79, 89, 99, 0.8);
}

.max-h-content {
  max-height: calc(100dvh);
  max-height: calc(100vh);
}

@media (min-width: 1023px) {
  .popup{
    max-width: 30rem;
  }
}

@media (max-width: 640px) {
  .popup--show-side {
    transform: translate(-50%, -30%);
    pointer-events: all;
    opacity: 1;
  }
  .max-h-content {
    max-height: calc(100dvh);
    max-height: calc(100vh);
  }
  .popup--show {
    pointer-events: all;
    opacity: 1;
    transform: translate(-50%, 8%);
  }
  .popup--show-no-drawer{
    pointer-events: all;
    opacity: 1;
    transform: translate(-50%, -50%);
    border-radius: 0;
  }
}
</style>
